import { render, staticRenderFns } from "./exportReportDistribusi.vue?vue&type=template&id=3f31cbee"
import script from "./exportReportDistribusi.vue?vue&type=script&lang=js"
export * from "./exportReportDistribusi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports